import { AbstractApiModel } from './abstract-api-model';
import { PlayExecution } from './play-execution';
import { ScanZone } from './scan-zone';

export class ScanZoneExecution extends AbstractApiModel<ScanZoneExecution> {
  message: string;
  status: string;
  processStatus: string;
  scanType: string;
  eventData: any;
  robotScanZoneExecutionId: string;
  statusReason: string;

  rfidScanEventId: number;
  scanStartedAt: Date;
  scanFinishedAt: Date;
  processStartedAt: Date;
  processFinishedAt: Date;
  uploadStartedAt: Date;
  uploadFinishedAt: Date;

  playExecutionId: number;
  scanZoneId: number;

  playExecution: PlayExecution;
  scanZone: ScanZone;

  deserialize(json: any): this {
    this.message = json.message;
    this.status = json.status;
    this.processStatus = json.process_status;
    this.eventData = json.event_data;
    this.scanType = json.scan_type;
    this.robotScanZoneExecutionId = json.robot_scan_zone_execution_id;
    this.rfidScanEventId = json.rfid_scan_event_id;
    this.scanStartedAt = json.scan_started_at;
    this.scanFinishedAt = json.scan_finished_at;
    this.processStartedAt = json.process_started_at;
    this.processFinishedAt = json.process_finished_at;
    this.uploadStartedAt = json.upload_started_at;
    this.uploadFinishedAt = json.upload_finished_at;
    this.playExecutionId = json.play_execution_id;
    this.scanZoneId = json.scan_zone_id;

    return super.deserialize(json);
  }
}
